export class TrameroSearchModel {
    public ComunidadAutonoma: string = "";
    public Provincia: string = "";
    public Municipio: string = "";
    public TipoVia: string = "";
    public NombreVia: string | undefined;
}